<script setup>
import { computed } from 'vue';

const props = defineProps({
  platform: { type: String, default: 'facebook' },
  size: { type: String, default: 'sm' },
});

const config = computed(() => {
  const map = {
    facebook: {
      label: 'Facebook',
      icon: 'i-ri-facebook-fill',
      color: 'bg-blue-100 text-blue-700',
    },
    instagram: {
      label: 'Instagram',
      icon: 'i-ri-instagram-line',
      color: 'bg-pink-100 text-pink-700',
    },
    tiktok: {
      label: 'TikTok',
      icon: 'i-ri-tiktok-fill',
      color: 'bg-slate-100 text-slate-800',
    },
    twitter: {
      label: 'Twitter/X',
      icon: 'i-ri-twitter-x-fill',
      color: 'bg-sky-100 text-sky-700',
    },
  };
  return (
    map[props.platform] || {
      label: props.platform,
      icon: 'i-lucide-globe',
      color: 'bg-n-slate-3 text-n-slate-11',
    }
  );
});

const sizeClasses = computed(() =>
  props.size === 'xs'
    ? 'text-[10px] px-1.5 py-0.5 gap-1'
    : 'text-xs px-2 py-1 gap-1.5'
);
</script>

<template>
  <span
    class="inline-flex items-center rounded-md font-medium"
    :class="[config.color, sizeClasses]"
  >
    <span :class="config.icon" class="size-3" />
    <span>{{ config.label }}</span>
  </span>
</template>
